import { range } from "@/shared/utils/Arrays.ts";

export class Color {
  constructor(
    public readonly r: number,
    public readonly g: number,
    public readonly b: number,
    public readonly a = 255,
  ) {}

  static fromArray(numbers: number[]): Color {
    if (numbers.length < 3) {
      throw new Error("Needs at least 3 values (r, g, b)");
    }
    if (numbers.length > 4) {
      throw new Error("Needs at most 4 values (r, g, b, a)");
    }
    return new Color(numbers[0], numbers[1], numbers[2], numbers[3] ?? 255);
  }

  static fromHexaValue(hexaColor: string): Color {
    const offset = hexaColor.startsWith("#") ? 1 : 0;
    const numbers = range(hexaColor.length, offset, 2)
      .map((i) => [i, i + 2])
      .map(([start, end]) => hexaColor.substring(start, end))
      .map((h) => parseInt(h, 16));
    if (numbers.includes(NaN) || numbers.length < 3) {
      throw new Error(`Failed to parse string: '${hexaColor}'`);
    }
    return Color.fromArray(numbers);
  }

  public luminance(): number {
    return (0.299 * this.r + 0.587 * this.g + 0.114 * this.b) / 255;
  }

  public isLight(): boolean {
    return this.luminance() > 0.5;
  }
}
